import ABCyaPhaser from "@abcya/abcya_phaser";
import AScene from "../../library/ExtendedObjects/AScene.js";
import FontKeys from "../../FontKeys.js";
import ABCyaLib from "@abcya/abcya_lib";

export default class PauseMenu extends AScene
{
    static get KEY() { return 'PausePopUp'; }
    create()
        {
            this.PauseBackDrop = this.add.rectangle(0,0,1024,768,'#333840',.3);
            this.PauseBackDrop.setOrigin(0,0);
            const MenuBack = this.add.container(683,this.mid.y);
            const MenuBackDrop = this.addImage(0, 0, 'Menus_Popups/Menu_Popup');
            const MenuLabel = ABCyaPhaser.Text.addText(0, -112, 92, 0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString('done_popup.menu'), this);
            MenuLabel.setShadow(-3, 2, '#f58820', 0, true, true);

            MenuBack.add([MenuBackDrop, MenuLabel]);

            const menuBounds = MenuBackDrop.getBounds();

            const Cancel = this.addButton(menuBounds.right-36,menuBounds.top+36, 'Menus_Popups/X');
            const NewButton = this.addButton(menuBounds.left+100,menuBounds.bottom-100, 'Menus_Popups/New'); 
            const PrintButton = this.addButton(MenuBack.x,menuBounds.bottom-100, 'Menus_Popups/Print');
            const SaveButton = this.addButton(menuBounds.right-100,menuBounds.bottom-100, 'Menus_Popups/Save');
            const Buttons = [Cancel,NewButton,PrintButton,SaveButton];
            var SendData = {Action: "null"};

            const newText = ABCyaPhaser.Text.addText(NewButton.x, 356, 56, 0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString('done_popup.new'), this).setShadow(-4, 3, '#f58820', 0, true, true);
            const printText = ABCyaPhaser.Text.addText(PrintButton.x, 356, 56, 0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString('done_popup.print'), this).setShadow(-4, 3, '#f58820', 0, true, true);
            const saveText = ABCyaPhaser.Text.addText(SaveButton.x, 356, 56, 0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString('done_popup.save'), this).setShadow(-4, 3, '#f58820', 0, true, true);

            if (ABCyaLib.Environment.instance.locale === 'es-US') {
              newText.setFontSize(42);
              printText.setFontSize(42);
              saveText.setFontSize(42);
            }

            for(let x in Buttons)
            {
                Buttons[x].setOrigin(.5,.5);
            }

            Cancel.once('pointerdown',()=>{
                this.scene.resume('PlaceItems',SendData);
                this.playSound('button_menu_click');
                this.scene.stop();
            });

            NewButton.once('pointerdown',()=>{
                SendData.Action = "New";
                this.playSound('button_menu_click');
                this.scene.resume('PlaceItems',SendData);
                this.scene.stop();
            });

            PrintButton.once('pointerdown',()=>{
                SendData.Action = "Print";
                this.playSound('button_menu_click');
                this.scene.resume('PlaceItems',SendData);
                this.scene.stop();
            });

            SaveButton.once('pointerdown',()=>{
                SendData.Action = "Save";
                this.playSound('button_menu_click');
                this.scene.resume('PlaceItems',SendData);
                this.scene.stop();
            });
        }
}